import * as yup from "yup";

const ejectionReportSchema = yup.object().shape({
    gameId: yup.number().required(),
    firstName: yup
        .string()
        .optional()
        .transform((value, originalValue) => (!value ? "" : originalValue)),
    lastName: yup
        .string()
        .optional()
        .transform((value, originalValue) => (!value ? "" : originalValue)),
    report: yup.string().required("Please submit a report"),
});

export default ejectionReportSchema;
